
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 8.083c2.292 0 4.24-.359 5.844-1.077s2.406-1.581 2.406-2.59c0-1.008-.802-1.87-2.406-2.589C13.24 1.11 11.292.75 9 .75c-2.292 0-4.24.359-5.844 1.077S.75 3.408.75 4.417c0 1.008.802 1.871 2.406 2.59C4.76 7.723 6.708 8.082 9 8.082zm0 2.292c.626 0 1.41-.065 2.349-.195.94-.13 1.845-.34 2.716-.63.87-.29 1.619-.668 2.245-1.134.627-.466.94-1.035.94-1.708V9c0 .672-.313 1.241-.94 1.707-.626.466-1.375.844-2.245 1.135-.871.29-1.776.5-2.716.63-.94.13-1.723.195-2.349.195-.626 0-1.41-.065-2.349-.195a15.12 15.12 0 01-2.716-.63c-.87-.29-1.619-.669-2.245-1.135C1.063 10.241.75 9.672.75 9V6.708c0 .673.313 1.242.94 1.708.626.466 1.375.844 2.245 1.134.871.29 1.776.5 2.716.63.94.13 1.723.195 2.349.195zm0 4.583c.626 0 1.41-.065 2.349-.194.94-.13 1.845-.34 2.716-.63.87-.29 1.619-.67 2.245-1.135.627-.466.94-1.035.94-1.707v2.291c0 .673-.313 1.242-.94 1.708-.626.466-1.375.844-2.245 1.134-.871.29-1.776.5-2.716.63-.94.13-1.723.195-2.349.195-.626 0-1.41-.065-2.349-.195-.94-.13-1.845-.34-2.716-.63-.87-.29-1.619-.668-2.245-1.134-.627-.466-.94-1.035-.94-1.708v-2.291c0 .672.313 1.241.94 1.707.626.466 1.375.844 2.245 1.134.871.29 1.776.5 2.716.63.94.13 1.723.195 2.349.195z"}})])
          )
        }
      }
    